'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var channel = function channel() {
  return import('@/page/channel');
};
var channelColumn = function channelColumn() {
  return import('@/page/channel/column');
};
var resultsShow = function resultsShow() {
  return import('@/page/channel/results-show');
};
var columnInformationDetail = function columnInformationDetail() {
  return import('@/page/dynamic/information-detail');
};
var columnsAll = function columnsAll() {
  return import('@/page/specialPage/columns-all');
};

exports.default = [{
  path: '/channel',
  name: 'channel',
  component: channel,
  children: [{
    path: 'channelColumn',
    name: 'channelColumn',
    component: channelColumn
  }, {
    path: 'resultsShow',
    name: 'resultsShow',
    component: resultsShow
  }, {
    path: 'columnInformationDetail',
    name: 'columnInformationDetail',
    component: columnInformationDetail
  }]
}, {
  path: '/columnsAll',
  name: 'columnsAll',
  component: columnsAll
}];